// ─── Carte de propriétés (Core) ───────────────────────────────────
// Toutes les fiches d'information affichent leurs propriétés de la MÊME façon :
// icône, libellé, valeur à droite, séparateur entre les lignes. Un composant
// partagé évite que deux fiches divergent — de présentation comme de
// vocabulaire.
//   <CarteInfos rows={[{ ic:'🏠', lbl:'Espace', val:'Maison' }]} />
// `onPress` sur une ligne la rend actionnable (valeur en accent + chevron).
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';

export default function CarteInfos({ rows = [], style }) {
  const UI = useUI();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <View style={[s.carte, style]}>
      {rows.filter(Boolean).map((r, i) => {
        const contenu = (
          <>
            <Text style={s.ic}>{r.ic}</Text>
            <Text style={s.lbl}>{r.lbl}</Text>
            <Text style={[s.val, r.onPress && { color: UI.accent }]} numberOfLines={2}>{r.val}</Text>
          </>
        );
        return r.onPress
          ? <TouchableOpacity key={i} style={[s.row, i > 0 && s.sep]} activeOpacity={0.7} onPress={r.onPress}>{contenu}</TouchableOpacity>
          : <View key={i} style={[s.row, i > 0 && s.sep]}>{contenu}</View>;
      })}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  carte: { backgroundColor: UI.card, borderRadius: 13, borderWidth: 0.5, borderColor: UI.border, paddingHorizontal: 12 },
  row: { flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 11 },
  sep: { borderTopWidth: 0.5, borderTopColor: UI.border },
  ic: { fontSize: 15, width: 20, textAlign: 'center' },
  lbl: { flex: 1, fontSize: 12.5, color: UI.muted },
  val: { fontSize: 13.5, color: UI.ink, fontWeight: '700', textAlign: 'right', maxWidth: '55%' },
});
